import { render } from "./caseC.vue?vue&type=template&id=5b299073&scoped=true"
import script from "./caseC.vue?vue&type=script&lang=js"
export * from "./caseC.vue?vue&type=script&lang=js"

import "./caseC.vue?vue&type=style&index=0&id=5b299073&scoped=true&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b299073"]])

export default __exports__